import { Component } from '@angular/core';

@Component({
  selector: 'app-default-shimmer',
  templateUrl: './default-shimmer.component.html',
  styleUrls: ['./default-shimmer.component.scss'],
})
export class DefaultShimmerComponent {
  trackByIndex(index: number, item: any): number {
    return index;
  }
}
